<template>
  <label class="label" :class="{ 'label--compact': compact }">
    <slot />
    <base-label-tooltip
      v-if="required && tooltipText"
      :text="requiredTooltipText"
      :filled="filled"
    />
    <BaseInfoTooltip v-if="displayInfo" :text="displayInfo" :filled="filled" />
  </label>
</template>

<script type="text/javascript">
import { fieldInfoByKey } from "@/config/fieldInfo";

export default {
  name: "BaseLabel",
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    filled: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: "Это поле обязательно для заполнения",
    },
    info: {
      type: String,
      default: "",
    },
    // Ключ из src/config/fieldInfo.js для единого текста подсказки
    infoKey: {
      type: String,
      default: "",
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },

  computed: {
    requiredTooltipText() {
      return this.filled
        ? "Обязательное поле заполнено"
        : this.tooltipText;
    },
    displayInfo() {
      return this.info || fieldInfoByKey(this.infoKey);
    },
  },
};
</script>

<style scoped>
.label {
  display: flex;
  align-items: center;
  min-height: 16px;
  gap: 4px;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 14px;
}

.label--compact {
  margin-bottom: 0;
}
</style>
